export default __webpack_public_path__ + "static/media/environmental-impact.3bfa34be.svg";